import React, { useEffect } from 'react';
// import { SearchComponent } from '../../vanillaComponent/search-component';
import { SearchComponent } from '../../vanillaComponent/search-component/SearchComponent';
import { IframeOpener } from '../../vanillaComponent/iframe-opener';

function TradeInWidget() {
  const initRef = React.useRef(false);
  useEffect(() => {
    if (initRef.current) return;
    initRef.current = true;

    const searchContainer = document.getElementById('search-container');
    const openIframeContainer = document.getElementById('open-iframe');

    // Check if the SearchComponent is already rendered in the container
    if (searchContainer && searchContainer.children.length === 0) {
      const widgetData = {
        token: 'dFJkNGVSUllxeTloMkxxc2I2cVZ2dHBt', // 'YVNMekFnUVJLWFJzZXhXeFNuMHJOMksy', //'Z1BJRUZuS2U0dUl6UnNua2FMSGw4OGdm',
        type: 'banner',
        version: '1.1',
        module: 'trade-in',
        design: 'design1',
      };

      const searchComponent = new SearchComponent(widgetData);
      searchComponent.render(searchContainer);

      // const banner = new AffordabilityBanner(widgetData);
      // banner.render(searchContainer);

      // Additional logic or configuration for the searchComponent
    }

    if (openIframeContainer && !openIframeContainer.querySelector('[id^="open-iframe-button"]')) {
      const iframeUrl = `${import.meta.env.VITE_HOST_URL}/trade-in/Z1BJRUZuS2U0dUl6UnNua2FMSGw4OGdm`; // Replace with the actual URL

      const widgetData = {
        // containerSelector: 'open-iframe',
        // buttonName: 'Free Trade-In Estimate',
        token: 'dFJkNGVSUllxeTloMkxxc2I2cVZ2dHBt',
        // iframeUrl: iframeUrl,
        type: 'button',
        version: '1.1',
        // customClassName: 'custom-class-name',
        module: 'trade-in',
      };

      new IframeOpener(widgetData).render(openIframeContainer);

      // iframeOpener.render(openIframeContainer);
      // Apply custom style directly here
    }

    const openIframeContainerNew = document.getElementById('open-iframe-new');

    if (openIframeContainerNew && !openIframeContainerNew.querySelector('[id^="open-iframe-button"]')) {
      const widgetData = {
        token: 'eVcweWJyRHRDUkhQb0JjZWpMdFFMcndK', // 'eURWNzJ0dENOTFJCTkJLVjVQVkFNNjJI', // 'eVcweWJyRHRDUkhQb0JjZWpMdFFMcndK',

        type: 'button',
        version: '1.0',

        module: 'credit-score',
      };

      new IframeOpener(widgetData).render(openIframeContainerNew);
    }

    // If you need to clean up or perform actions when the component is unmounted,
    // you can return a cleanup function from the useEffect.
    return () => {
      // Cleanup logic (if needed)
    };
  }, []); // Empty dependency array means this effect runs only once

  return (
    <>
      <div id='search-container'></div>

      {/* <iframe
        title='Example HTML'
        src='/htmlPages/search_trade_in.html'
        style={{ paddingTop: '50px', border: 'none' }}
        width='100%'
        height='300px'
      ></iframe> */}

      <div
        style={{
          position: 'absolute',
          top: '60%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
      >
        <div id='open-iframe'></div>
        <div id='open-iframe-new'></div>
      </div>

      {/* <iframe
        title='Example HTML'
        src='/htmlPages/popup_trade_in.html'
        style={{ paddingTop: '100px', border: 'none' }}
        width='100%'
        height='300px'
      ></iframe> */}

      <div id='search-component-container'></div>
    </>
  );
}

export default TradeInWidget;
